import { string, number, object } from 'yup';
import i18n from 'i18next';

export const schema = {
  unitType: object().required(i18n.t('common.fieldRequiredMessage')),
  type: string().required(i18n.t('common.fieldRequiredMessage')),
  beginDate: string().required(i18n.t('common.fieldRequiredMessage')),
  endDate: string().required(i18n.t('common.fieldRequiredMessage')),
  mileage: number().when('unitType', {
    is: (val) => val?.value === 'VEHICLE',
    then: (schema) =>
      schema
        .required(i18n.t('common.fieldRequiredMessage'))
        .typeError(i18n.t('common.validNumberMessage'))
        .positive(i18n.t('common.positiveNumberMessage')),
    otherwise: (schema) => schema.notRequired().nullable(true),
  }),
};
